import { cssColors, defineCss } from '@src/style/style';

export default function applyWifiStyles () {
  defineCss('.network-bold', 'font-weight: 700;');
  defineCss('.bigger', 'font-size: 24px;');

  defineCss('.app-button',
    'flex-direction: column;' +
        'margin-bottom: 15px;' +
        'cursor:pointer;',
  );

  defineCss('.app-button-title',
    'color: white; background: #1C344F;' +
        'border-radius: 3px;' +
        'font-family: Larsseit; font-style: normal; font-weight: 400; font-size: 18px; line-height: 29px;' +
        'padding: 10px;',
  );
  defineCss('.app-button-title.selected', 'color: white; font-weight: 700; background: #1E2631;');
  defineCss('.app-button-title.expanded', 'border-radius: 3px 3px 0 0;');

  defineCss('.app-options', 'flex-direction: column; cursor:pointer;');
  defineCss('.app-option',
    'height: 3rem; ' +
        'box-sizing: border-box;' +
        'display: grid; grid-template-columns: 4px minmax(0, 1fr) 50px; grid-gap: 0.1rem; align-items: center;' +
        'border-bottom: 1px solid #EFF2F7; border-left: 1px solid #EFF2F7; border-right: 1px solid #EFF2F7;',
  );

  defineCss('.app-option:last-child', 'border-left: 1px solid #EFF2F7; border-right: 1px solid #EFF2F7; border-bottom: 1px solid #EFF2F7; border-radius: 0 0 3px 3px;');
  defineCss('.app-option.selected', 'background-color:#EFF2F7;');
  // we will offset it by one pixel to compnesate for the border of app-options, otherwise there is a visible gap for the fist selected element
  defineCss('.app-option.selected .app-option-selector', 'background-color: #1C344F; position: relative; right: 1px;');
  defineCss('.app-option.selected:last-child', 'background-color:#EFF2F7;');

  defineCss('.app-right',
    'display: flex; flex-direction: column;' +
        'padding: 20px; margin: 20px;',
  );

  defineCss('.app-right-card-container',
    'width: 25rem;',
  );

  defineCss('.app-right-card-inner',
    'justify-content: center;' +
        'gap: 20px; padding: 20px; margin: 20px;',
  );

  defineCss('.app-right-full-container',
    'align-items: stretch; justify-content: stretch;' +
        'width: 100%; height:100%;',
  );

  defineCss('.app-right-full-inner',
    'flex-grow: 1;' +
        'height:80%;' +
        'gap: 20px; padding: 20px; margin: 20px;' +
        `border: 1px solid ${cssColors.border_color}; border-radius: 5px;` +
        'background-color: #FBFBFB;',
  );

  defineCss('.center-column', 'align-self: center;');

  defineCss('.app-button-title', 'display: none important!; ');
}
